<template>
  <div>
    <AdminMenu v-if="isAdmin" data-test="icon-admin" />
    <UserIconAndSubMenu v-else />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import AdminMenu from './AdminMenu.vue'
import UserIconAndSubMenu from './UserIconAndSubMenu/UserIconAndSubMenu.vue'

const { user, isUserAuthenticatedStaff } = useUserStore()

const isAdmin = computed(
  () =>
    isUserAuthenticatedStaff.value ||
    user.value.isShadowingClient ||
    user.value.isShadowingMerchant,
)
</script>
